import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'

const getOrderingOptionsLabel = (type: string) => {
  switch (type) {
    case 'asc':
      return i18n.t('custom_reports.ordering_options.asc')
    case 'desc':
      return i18n.t('custom_reports.ordering_options.desc')
    case 'no_order':
      return i18n.t('custom_reports.ordering_options.no_order')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  fieldType: FieldType
}

const OrderingInfo = ({ fieldType }: Props) => {
  const value = fieldType.form.get('order').value

  return (
    <Box flexDirection="row">
      <Text.Normal color="grey1000" size="200" weight="medium">
        {i18n.t('custom_reports.ability_labels.order_by')}:&nbsp;
      </Text.Normal>
      <Text.Normal color="grey1000" size="200">
        {getOrderingOptionsLabel(value ?? '')}
      </Text.Normal>
    </Box>
  )
}

export default observer(OrderingInfo)
